/** Medio arco SVG (estilo del HTML de Andrea): valor 0-100 con color por tono. */
export function Gauge({ value, color, label }: { value: number; color: string; label: string }) {
  const r = 54;
  const c = Math.PI * r; // media circunferencia
  const pct = Math.max(0, Math.min(100, value));
  const dash = (pct / 100) * c;
  return (
    <div className="flex flex-col items-center">
      <svg viewBox="0 0 140 80" className="h-20 w-36">
        <path d="M 16 70 A 54 54 0 0 1 124 70" fill="none" stroke="currentColor" strokeWidth="14" strokeLinecap="round" className="text-muted/60" />
        <path d="M 16 70 A 54 54 0 0 1 124 70" fill="none" stroke={color} strokeWidth="14" strokeLinecap="round" strokeDasharray={`${dash} ${c}`} />
        <text x="70" y="68" textAnchor="middle" className="fill-current text-2xl font-bold" style={{ fontSize: 24 }}>{pct}%</text>
      </svg>
      <p className="mt-1 text-xs font-medium text-muted-foreground">{label}</p>
    </div>
  );
}
